<template>
    <div class="d-flex" style="gap:10px;">
        <div class="form-group bmd-form-group is-filled" style="width: 70%;">
            <input
                name="title_input_19239adas02"
                v-model="text[languages[selectedIndex].key]"
                class="form-control"
            />
        </div>
        <div class="dropdown">
            <button
                class="btn btn-success dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                {{ languages[selectedIndex].value }}
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div
                    v-for="(language, lKey) in languages"
                    :key="lKey"
                    class="dropdown-item"
                    @click="selectLanguage(lKey)"
                >
                    <div class="d-flex" style="gap:10px; align-items: center;">
                        {{ language.value }}
                        <span v-if="text[language.key]" class="label-success"
                            >OK</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <span class="text-danger">
            <span v-if="text['tr_TR'] === undefined || text['tr_TR'] === ''">
                Zorunlu: [TR]
            </span>
        </span>
        <template v-if="createHiddenInput">
            <div v-for="(item, iKey) in Object.entries(text)" :key="iKey">
                <input
                    :id="`id_[${item[0]}]`"
                    :name="`${name}[${item[0]}]`"
                    type="hidden"
                    :value="item[1]"
                />
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: ["name", "value", "createHiddenInput"],
    data() {
        return {
            text: {},
            selectedIndex: 0
        };
    },
    computed: {
        languages() {
            let final = [];

            const languages = JSON.parse(
                process.env.MIX_LANGUAGES.replaceAll("'", '"')
            );

            const placeholders = JSON.parse(
                process.env.MIX_LANGUAGES_PLACEHOLDERS.replaceAll("'", '"')
            );

            for (let i = 0; i < languages.length; i++) {
                final.push({
                    key: languages[i],
                    value: placeholders[i]
                });
            }

            return final;
        }
    },
    methods: {
        selectLanguage(index) {
            this.selectedIndex = index;
        }
    },
    mounted() {
        if (this.value) {
            this.text = this.value;
        } else {
            // if empty initialize with tr_TR
            this.text = { tr_TR: "" };
        }
    }
};
</script>
<style>
.label-success {
    color: white;
    background-color: green;
    padding: 2px 10px 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 800;
    text-align: center;
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// resources/vue/@components/i18n-text.vue